module.exports = __webpack_public_path__ + "static/media/checkbox-tick.00a48a9b.svg";